import { CdkTrapFocus } from '@angular/cdk/a11y';
import { ComponentType } from '@angular/cdk/overlay';
import { NgClass, NgComponentOutlet, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, inject } from '@angular/core';

import { ArrowPosition } from './popover-data.interface';
import { PopoverRef } from './popover-ref';
import { POPOVER_DATA } from './popover.tokens';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  imports: [NgClass, NgStyle, NgTemplateOutlet, NgComponentOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [CdkTrapFocus],
})
export class PopoverComponent {
  readonly #popoverRef = inject(PopoverRef);
  public readonly data = inject(POPOVER_DATA);

  public arrowPosition?: ArrowPosition;

  public constructor() {
    inject(CdkTrapFocus).autoCapture = true;
  }

  public isTemplate(tooltip: string | TemplateRef<unknown> | ComponentType<unknown>): tooltip is TemplateRef<unknown> {
    return tooltip instanceof TemplateRef;
  }

  public isComponent(tooltip: string | TemplateRef<unknown> | ComponentType<unknown>): tooltip is ComponentType<unknown> {
    return typeof tooltip === 'function';
  }

  public closeTooltip(): void {
    this.#popoverRef.close();
  }
}
